import { render, staticRenderFns } from "./FieldsAutoSuggest.vue?vue&type=template&id=3fc49385&"
import script from "./FieldsAutoSuggest.vue?vue&type=script&lang=js&"
export * from "./FieldsAutoSuggest.vue?vue&type=script&lang=js&"
import style0 from "./FieldsAutoSuggest.vue?vue&type=style&index=0&id=3fc49385&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports